import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/RequestNDA.css';
import emailjs from 'emailjs-com';

function RequestNDA() {
  const { language } = useLanguage();
  const [formData, setFormData] = useState({
    companyName: '',
    companyAddress: '',
    fullName: '',
    email: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const templateParams = {
      companyName: formData.companyName,   
      companyAddress: formData.companyAddress,
      fullName: formData.fullName,
      email: formData.email,
    };

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then((result) => {
      alert('✅ Email sent successfully!');
      setFormData({ companyName: '', companyAddress: '', fullName: '', email: '' }); 
    })
    .catch((error) => {
      alert('❌ Failed to send email. Please try again.');
    });
  };
     
  return (
    <div className="nda-container">
      <h1 className="nda-title">
        {language === 'en' ? 'Non-Disclosure Agreement (NDA)' : 'Geheimhaltungsvereinbarung (NDA)'}
      </h1>
      <p className="nda-text">
        {language === 'en' 
          ? 'At Morrow Collective, we understand the importance of confidentiality when dealing with sensitive business information. As we are dedicated to helping many other start-ups and scale-ups secure (public) funding, we routinely handle intellectual property, financial insights, and pitch decks. We know how crucial it is to protect your innovative ideas, technological/scientific insights, and business strategies.'
          : 'Bei Morrow Collective verstehen wir die Bedeutung der Vertraulichkeit beim Umgang mit sensiblen Geschäftsinformationen. Da wir uns darauf konzentrieren, anderen Start-ups und Scale-ups bei der Sicherung (öffentlicher) Finanzierung zu helfen, arbeiten wir regelmäßig mit geistigem Eigentum, finanziellen Einblicken und Pitch-Decks. Wir wissen, wie wichtig es ist, Ihre innovativen Ideen, technologischen/wissenschaftlichen Erkenntnisse und Geschäftsstrategien zu schützen.'}
      </p>
      <p className="nda-text">
        {language === 'en'
          ? 'To ensure your peace of mind and safeguard your valuable information, we are happy to establish a Non-Disclosure Agreement (NDA) with you. Whether you\'re sharing confidential data related to public funding applications, business plans, or proprietary knowledge, our NDA ensures complete privacy and security.'
          : 'Um Ihnen Sicherheit zu geben und Ihre wertvollen Informationen zu schützen, sind wir gerne bereit, eine Geheimhaltungsvereinbarung (NDA) mit Ihnen abzuschließen. Egal, ob Sie vertrauliche Daten im Zusammenhang mit öffentlichen Finanzierungsanträgen, Geschäftsplänen oder proprietärem Wissen teilen, unsere NDA gewährleistet absolute Privatsphäre und Sicherheit.'}
      </p>
      <p className="nda-text">
        {language === 'en'
          ? 'If you\'d like to proceed with an NDA, please fill out the form below and provide the necessary details. We\'ll get back to you promptly to finalize the agreement.'
          : 'Wenn Sie mit einer NDA fortfahren möchten, füllen Sie bitte das folgende Formular aus und geben Sie die erforderlichen Details an. Wir werden uns umgehend bei Ihnen melden, um die Vereinbarung abzuschließen.'}
      </p>

      <form className="nda-form" onSubmit={handleSubmit}>
        <label className="nda-label">
          {language === 'en' ? 'Company Name' : 'Unternehmensname'}
        </label>
        <input
          type="text"
          name="companyName"
          placeholder={language === 'en' ? 'Example: Growth&Partners GmbH' : 'Beispiel: Growth&Partners GmbH'}
          className="nda-input"
          value={formData.companyName}
          onChange={handleChange}
          required
        />

        <label className="nda-label">
          {language === 'en' ? 'Company Address' : 'Unternehmensadresse'}
        </label>
        <input
          type="text"
          name="companyAddress"
          placeholder={language === 'en' ? 'Example: Schönhauser Allee 9, 10119 Berlin' : 'Beispiel: Schönhauser Allee 9, 10119 Berlin'}
          className="nda-input"
          value={formData.companyAddress}
          onChange={handleChange}
          required
        />

        <label className="nda-label">
          {language === 'en' ? 'Full Name of Signatory' : 'Vollständiger Name des Unterzeichners'}
        </label>
        <input
          type="text"
          name="fullName"
          placeholder={language === 'en' ? 'Add full name of managing director' : 'Vollständiger Name des Geschäftsführers'}
          className="nda-input"
          value={formData.fullName}
          onChange={handleChange}
          required
        />

        <label className="nda-label">
          {language === 'en' ? 'Email of the Signatory' : 'E-Mail des Unterzeichners'}
        </label>
        <input
          type="email"
          name="email"
          placeholder={language === 'en' ? 'Add email for eSignature' : 'E-Mail für elektronische Unterschrift'}
          className="nda-input"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <button type="submit" className="nda-button">
          {language === 'en' ? 'Submit' : 'Absenden'}
        </button>
      </form>

      <p className="nda-contact">
        {language === 'en'
          ? 'If you have any questions or need assistance, feel free to contact us at '
          : 'Wenn Sie Fragen haben oder Hilfe benötigen, kontaktieren Sie uns gerne unter '}
        <a href="mailto:hello@morrowcollective.eu">hello@morrowcollective.eu</a>.
      </p>
    </div>
  );
}

export default RequestNDA;
